import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './styles/theme.css';
import './styles/login_page.css';
import './styles/users_admin_list_view.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { logError, logSystemEvent } from './utils/logs';

window.addEventListener('error', event => {
	logError('Global JavaScript error', event.error, {
		message: event.message,
		filename: event.filename,
		lineno: event.lineno,
		colno: event.colno,
		url: window.location.href,
		userAgent: navigator.userAgent,
		timestamp: new Date().toISOString(),
	});
});

window.addEventListener('unhandledrejection', event => {
	logError('Unhandled promise rejection', event.reason, {
		url: window.location.href,
		userAgent: navigator.userAgent,
		timestamp: new Date().toISOString(),
	});
});

logSystemEvent('Application started', 'info', {
	url: window.location.href,
	userAgent: navigator.userAgent,
	timestamp: new Date().toISOString(),
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

reportWebVitals();
